import { axiosGet, axiosPost } from '../../../services/ServiceBase';

/**
 * save reclamo
 * @returns
 */
export const saveDenunciaService = async (denuncia) => {
  const salida = await axiosPost('/v1/denuncia', denuncia);
  return salida;
};

/**
 * get reclamos
 * @returns
 */
export const getDenunciasService = async () => {
  const salida = await axiosGet('/v1/denuncia');
  return salida;
};

/**
 * get reclamos
 * @returns
 */
export const getDenunciaService = async (id) => {
  const salida = await axiosGet(`/v1/denuncia/${id}`);
  return salida;
};

/** anular reclamo
 * @returns
 */
export const anularDenuncia = async (data) => {
  const salida = await axiosPost('/v1/denuncia/anular', data);
  return salida;
};
